import i18n from "i18next";

export class s {
  static auth = "auth";
  static aFourDigitVerificationCode = "aFourDigitVerificationCode";
  static continue = "Continue";
  static verification = "verification";
  static enterTheFourDigitCode = "enterTheFourDigitCode";
  static didNotGetTheCode = "didNotGetTheCode";
  static sendAgain = "sendAgain";
  static byContinueYouAgree = "byContinueYouAgree";
  static privacyPolicy = "privacyPolicy";
  static termsOfUse = "termsOfUse";
  static createPin = "createPin";
  static pinConfirmation = "pinConfirmation";
  static comeUpWithAPin = "comeUpWithAPin";
  static confirmThePin = "confirmThePin";
  static pinsDoNotMatch = "pinsDoNotMatch";
  static back = "back";
  static whoAreYou = "whoAreYou";
  static specifyYourRole = "specifyYourRole";
  static doctor = "doctor";
  static treatingThisIsMyMainGoal = "treatingThisIsMyMainGoal";
  static patient = "patient";
  static iNeedASolutionToTheProblem = "iNeedASolutionToTheProblem";
  static welcomeBack = "welcomeBack";
  static enterYourPin = "enterYourPin";
  static welcome = "welcome";
  static appointments = "appointments";
  static patientSearch = "patientSearch";
  static medecines = "medecines";
  static notes = "notes";
  static aiAssist = "AI assist";
  static startReception = "startReception";
  static startReceptionDesc = "startReceptionDesc";
  static startReceptionDesc2 = "startReceptionDesc2";
  static gptChatBotBySubscription = "gptChatBotBySubscription";
  static searchByMedicine = "searchByMedicine";
  static comparisonOfMedicines = "comparisonOfMedicines";
  static protocols = "protocols";
  static protocol = "protocol";
  static chatWithDanaAi = "chatWithDanaAi";
  static realTimeTranslate = "realTimeTranslate";
  static personalInformation = "personalInformation";
  static uploadYourPhoto = "uploadYourPhoto";
  static save = "save";
  static dateOfBirth = "dateOfBirth";
  static sip = "sip";
  static position = "position";
  static nameString = "nameString";
  static lastName = "lastName";
  static marketingAuthorizationStatus = "marketingAuthorizationStatus";
  static authorized = "authorized";
  static suspended = "suspended";
  static revoked = "revoked";
  static nonSubstitutedMedicines = "nonSubstitutedMedicines";
  static biologicals = "biologicals";
  static narrowTherapeuticMargin = "narrowTherapeuticMargin";
  static forTheRespiratorySystem = "forTheRespiratorySystem";
  static yourChose = "yourChose";
  static cleanAll = "cleanAll";
  static search = "search";
  static available = "available";
  static notAvailable = "notAvailable";
  static noResults = "noResults";
  static noResultsShort = "noResultsShort";
  static tryChangingTheRequest = "tryChangingTheRequest";
  static typesOfAnamnesis = "typesOfAnamnesis";
  static selectTheTypeOfAnamnesis = "selectTheTypeOfAnamnesis";
  static toStartTheConsultation = "toStartTheConsultation";
  static pharmaceuticalDoseForms = "pharmaceuticalDoseForms";
  static activeIngredients = "activeIngredients";
  static routesOfAdministration = "routesOfAdministration";
  static strength = "strength";
  static excipients = "excipients";
  static characteristics = "characteristics";
  static atcCodes = "atcCodes";
  static selectTypeOfAnamnesis = "selectTypeOfAnamnesis";
  static addToCompare = "addToCompare";
  static filters = "filters";
  static company = "company";
  static removeFromInteractions = "removeFromInteractions";
  static danaAssist = "danaAssist";
  static doYouHaveAQuestionForMe = "doYouHaveAQuestionForMe";
  static diagnosticImaging = "diagnosticImaging";
  static medicalCalculators = "medicalCalculators";
  static treatmentFormulation = "treatmentFormulation";
  static differentialCaseDiagnosis = "differentialCaseDiagnosis";
  static laboratoryResultsInterpretation = "laboratoryResultsInterpretation";
  static message = "message";
  static deleteNote = "deleteNote";
  static comparison = "comparison";
  static toStartComparisonSelectMedicines = "toStartComparisonSelectMedicines";
  static goToComparison = "goToComparison";
  static addMedicinesToCompare = "addMedicinesToCompare";
  static noInteractionsDescribed = "noInteractionsDescribed";
  static highDanger = "highDanger";
  static mediumDanger = "mediumDanger";
  static lowDanger = "lowDanger";
  static effect = "effect";
  static importance = "importance";
  static mechanism = "mechanism";
  static informationSource = "informationSource";
  static objectives = "objectives";
  static links = "links";
  static anamnesis = "anamnesis";
  static blockThePatient = "blockThePatient";
  static turnOffNotifications = "turnOffNotifications";
  static turnOnNotifications = "turnOnNotifications";
  static shareAnamnesis = "shareAnamnesis";
  static email = "email";
  static hasUnfinishedAnamnesis = "hasUnfinishedAnamnesis";
  static continueAnamnesis = "continueAnamnesis";
  static acceptChange = "acceptChange";
  static endAnamnesis = "endAnamnesis";
  static addPatientToChat = "addPatientToChat";
  static startChatWithPatient = "startChatWithPatient";
  static or = "or";
  static patientNotFound = "patientNotFound";
  static giveNameToPatient = "giveNameToPatient";
  static selectPatientToCompleteAppointment = "selectPatientToCompleteAppointment";
  static skip = "skip";
  static surname = "surname";
  static specialtyExternalConsultationReport = "specialtyExternalConsultationReport";
  static primaryCareClinicalReport = "primaryCareClinicalReport";
  static emergencyReport = "emergencyReport";
  static summaryClinicalHistory = "summaryClinicalHistory";
  static firstVisitDetailedSoap = "firstVisitDetailedSoap";
  static firstVisitConciseSoap = "firstVisitConciseSoap";
  static successiveVisitsEvolution = "successiveVisitsEvolution";
  static nursingCareReport = "nursingCareReport";
  static socialWorkerReport = "socialWorkerReport";
  static recipe = "recipe";
  static process = "process";
  static error = "error";
  static synchronousTranslator = "synchronousTranslator";
  static enterTextToTranslate = "enterTextToTranslate";
  static clickOnMicrophoneToStart = "clickOnMicrophoneToStart";
  static settings = "settings";
  static theme = "theme";
  static language = "language";
  static changePhone = "changePhone";
  static pinChange = "pinChange";
  static signOut = "signOut";
  static numberChange = "numberChange";
  static enterCurrentPhoneForVerification = "enterCurrentPhoneForVerification";
  static enterNewPhoneForVerification = "enterNewPhoneForVerification";
  static copy = "copy";
  static en = "en";
  static pt = "pt";
  static ua = "ua";
  static es = "es";
  static lightTheme = "lightTheme";
  static darkTheme = "darkTheme";
  static systemTheme = "systemTheme";
}